import { httpClient } from "@services/api/httpClient";

import { OfferApplicantStatus } from './../../../../types/OfferApplicantStatus.interface';

export async function updateAssessedCandidateStatus(id: number, status: OfferApplicantStatus) {
  const response = await httpClient.post(`/offer-applicant/update-assessed-candidate-status`, { offerApplicantId: id, status });
  return response.data;
}